import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TListBaseItem } from '../../../../components/base/BList/type';
import { schedulesActions } from '../../../../store/schedules/slice';
import { TMember, TScheduleShift } from '../../../../types';
import { commonActions } from '../../../../store/common/slice';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { ROUTES } from '../../../../data';
import { useSendScheduleAPI } from '../../../../hooks/api/useSchedules';
import { getScheduleList } from '../../../../store/schedules/selectors';
import { getMembers } from '../../../../store/team/selectors';

export function useCommonSchedules() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('team');
  const navigation = useNavigate();
  const scheduleList = useAppSelector(getScheduleList);
  const members = useAppSelector(getMembers);
  const { mutateAsync, isLoading: isStaffLoading } = useSendScheduleAPI();

  const openNav = () => {
    dispatch(schedulesActions.setSelectedScheduleShift({} as TScheduleShift));
    dispatch(schedulesActions.setSelectedShiftMember({} as TMember));
    dispatch(schedulesActions.setSelectedShiftDate(moment().format()));
    dispatch(commonActions.setIsOpenPagesNav(true));
  };

  const addShiftItems: Array<TListBaseItem> = [
    {
      name: t('addMany'),
      value: 'bulk',
      isSelected: false,
      action: () => navigation(ROUTES.SCHEDULES_BULK),
    },
    {
      name: t('addOne'),
      value: 'shift',
      isSelected: false,
      action: openNav,
    },
  ];

  const addTimeoff = () => {
    dispatch(commonActions.setIsOpenPagesNav(false));
    dispatch(schedulesActions.setIsOpenDayOffNav(true));
  };

  const sendToStaff = async (selectedDate: Moment) => {
    const startOfWeek = moment(selectedDate).startOf('week');
    const endOfWeek = moment(selectedDate).endOf('week');

    const schedules = Object.values(scheduleList).flatMap((day) => day.schedules.filter((schedule) => {
      const scheduleDate = moment(schedule.start);
      return scheduleDate.isBetween(startOfWeek, endOfWeek, null, '[]');
    }));

    const data = {
      schedulesData: schedules.filter((shift) => shift.email),
      locals: schedules?.map((shift) => ({
        email: shift.email,
        locale: members.find((member) => member.email === shift.email)?.locale || 'en',
      })),
    };

    await mutateAsync(data);
  };

  return {
    addShiftItems,
    addTimeoff,
    sendToStaff,
    isStaffLoading,
  };
}
